module.exports = __webpack_public_path__ + "img/addUser.1c940d5c.svg";